export enum HistoryCategory {
  UNA = 'UNA',
  CA = 'CA',
  SECTOR = 'SECTOR',
}
